import styled from 'styled-components';
import AvatarIcon from 'assets/cartoon.png';
import CartoonBg from 'assets/cartoon-modal-bg.svg';
import { Box, Text, Flex } from 'atoms';
import { theme } from 'styles/theme';

export const ShowDetailsWrapper = styled.div`
	width: 95px;
	height: 44px;
	border-radius: 50%;
	background: #fff;
	text-align: center;
	position: absolute;
	bottom: -22px;
	z-index: 1;
	left: 50%;
	cursor: pointer;
	transform: translateX(-50%);
`;
export const ShowDetailsArrow = styled(Flex)`
	width: 95px;
	height: 22px;
	margin-top: 22px;
	transform: rotate(180deg);
`;
export const AvatarImage = styled(Box)`
	border: 1px solid ${(props) => props.theme.colors.primary};
	width: 45px;
	height: 45px;
	border-radius: 50%;
	overflow: hidden;
	margin-right: 6px;
	background: url(${AvatarIcon}) no-repeat -25px 0px;
	background-size: 97px;
`;
export const AvatarName = styled(Text)`
	font-size: 12px;
	color: ${(props) => props.theme.colors.primary};
	font-weight: 600;
`;
export const PrimaryList = styled(Flex)`
	font-size: 12px;
	padding: 8px 10px;
	border-radius: 2px;
	margin-bottom: 5px;
	color: ${(props) => props.theme.colors.white};
	background: ${(props) => props.theme.colors.primary};
`;
export const PriceIcon = {
	borderRadius: '50%',
	marginRight: '16px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	background: theme.colors.BgBlue,
};
export const PrimaryNumber = styled(Flex)`
	width: 73px;
	height: 33px;
	font-weight: 600;
	border-radius: 2px;
	background: ${(props) => props.theme.colors.BgBlue};
`;
export const LabelAmount = {
	textAlign: 'right',
	fontWeight: '600',
};
export const CollectionDetailsTitle = styled(Text)`
	font-size: 6px;
	font-weight: 300;
`;
export const LabelText = styled(Text)`
	font-size: 10px;
	font-weight: 300;
`;
export const ModalBackground = styled.div`
	padding: 24px;
	margin: -24px;
	position: relative;
	background: url(${CartoonBg}) no-repeat bottom right;
`;
export const IconBgGray = styled(Flex)`
	width: 34px;
	height: 34px;
	border-radius: 50%;
	align-items: center;
	justify-content: center;
	border: 2px solid ${(props) => props.theme.colors.BgGrey};
	background: ${(props) => props.theme.colors.BgGrey};
`;
export const VerificationLabel = styled.div`
	font-size: 11px;
`;
export const VerificationLine = styled.div`
	height: 2px;
	width: 125px;
	margin: -16px -45px 0 -45px;
	background: ${(props) => props.theme.colors.BgGrey};
`;
export const IconBgGrayActive = {
	background: theme.colors.primary,
	border: theme.colors.primary,
};
export const VerificationLabelActive = {
	background: theme.colors.primary,
};
